// The app-wide "this student's data just changed, re-read yourself" signal.
//
// It lives in its own dependency-free module rather than in api.js so that a
// component can subscribe WITHOUT importing the API layer. Tests routinely
// vi.mock('../services/api') with a hand-written surface, and a mock that
// doesn't happen to list this export would otherwise crash any component that
// merely listens — a refresh concern breaking tests about something else.
export const PROGRESS_EVENT = 'stratia:progress-updated';

export const notifyProgress = () => {
  try { window.dispatchEvent(new Event(PROGRESS_EVENT)); } catch { /* non-browser/no-op */ }
};
